<template>
  <div class="withdraw_wrap cash-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.go(-1)"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <button
        type="button"
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="22"
        />
      </button>
    </div>

    <section class="balance-card">
      <p>{{ $t('sky.jifen') }}</p>
      <strong>{{ data.money }}</strong>
      <!-- <span>{{ $t('invest.availableBalance') }}</span> -->
    </section>

    <div class="wrap_box wrap1">
      <section
        class="choose_bank"
        @click="show = true"
      >
        <div class="choose-label">
          <span>{{ $t('cash.wallet') }}</span>
        </div>
        <div class="choose-value">
          <span>{{ bank_name }}</span>
          <van-icon name="arrow" />
        </div>
      </section>
      <van-action-sheet
        v-model="show"
        :actions="actions"
        cancel-text=""
        :description="this.$t('cash.chooseWallet')"
        close-on-click-action
        @select="onSelect"
      />

      <section class="amount-card">
        <p class="card-title">
          {{ $t('cash.amount') }}
        </p>
        <div class="amount-row">
          <span class="money-mark">{{ utils_moneyMark() }}</span>
          <input
            v-model="form.money"
            type="number"
            step="1"
            class="inp"
            :placeholder="$t('pro2.enteramount')"
            @input="changeAmount"
          >
          <button
            class="allbtn"
            type="button"
            @click="cashall()"
          >
            {{ $t('item.all') }}
          </button>
        </div>
        <p
          v-if="actualAmount"
          class="amount-preview"
        >
          {{ actualAmount }}
        </p>
        <p
          v-if="chargeTip"
          class="charge-tip"
        >
          {{ chargeTip }}
        </p>
      </section>

      <button
        type="button"
        class="basic_btn submit-btn"
        @click="write_psd = true; submitType = 1;"
      >
        {{ $t('utils.submit') }}
      </button>
      <p class="canal_tips">
        {{ $t('cash.arrivalTime') }}
      </p>
    </div>

    <van-popup
      v-model="write_psd"
      closeable
      close-icon="close"
      round
      position="bottom"
      class="password-popup"
    >
      <div class="psw_box">
        <van-password-input
          :value="psd_val"
          :mask="true"
          :focused="showKeyboard"
          @focus="showKeyboard = true"
        />
        <div class="keybord_box">
          <div class="keybord">
            <button
              v-for="i in 9"
              :key="'num-' + i"
              type="button"
              class="key_item"
              @click="onInput(i)"
            >
              <span class="key_inner">
                {{ i }}
              </span>
            </button>
            <div class="key_item no_bg">
              <div class="key_inner" />
            </div>
            <button
              type="button"
              class="key_item"
              @click="onInput(0)"
            >
              <span class="key_inner">
                0
              </span>
            </button>
            <button
              type="button"
              class="key_item no_bg x"
              @click="onDelete"
            >
              <span class="key_inner">
                x
              </span>
            </button>
          </div>
        </div>
      </div>
    </van-popup>

    <div
      v-show="setPwd"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('cash.setPwdFirst') }}
        </p>
        <button
          type="button"
          class="basic_btn"
          @click="setIniPwd"
        >
          {{ $t('cash.setNow') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import {
  DropdownMenu,
  DropdownItem,
  Popup,
  PasswordInput,
  NumberKeyboard,
  Icon,
  ActionSheet
} from 'vant';

Vue.use(PasswordInput).use(NumberKeyboard).use(Popup).use(DropdownMenu).use(DropdownItem).use(Icon).use(ActionSheet);

export default {
  name: "Cost",
  data() {
    return {
      data: {},
      showKeyboard: true,
      write_psd: false,
      psd_val: '',
      chargeTip: '',
      charge: 0,
      form: {
        money: '',
        password: '',
        bank_id: 0,
      },
      eye: 1,
      show: false,
      bank_name: this.$t('cash.chooseWallet'),
      actions: [],
      setPwd: false,
      submitType: 1,
      type: 1,
      rate: 1,
      mark: "$",
      actualAmount: ''
    };
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    this.start();
  },
  methods: {
    cashall() {
      this.form.money = this.data.money;
      this.changeAmount();
    },
    onSelect(item) {
      this.chargeTip = "";
      this.actualAmount = "";
      this.form.money = "";
      this.show = false;
      this.bank_name = item.name;
      this.form.bank_id = item.value;
      this.charge = item.charge;
      this.type = item.type;
      this.rate = item.rate;
      this.mark = item.mark;
      if (item.charge > 0) {
        this.chargeTip = this.$t('cash.charge') + item.charge + "%";
      } else {
        this.chargeTip = "";
      }
      if (item.value == 0) {
        this.$router.push('/addcountUsdt');
      }
    },
    changeAmount() {
      this.chargeTip = "";
      var rateTip = "";
      var num = 2;
      if (!this.form.money) {
        this.actualAmount = "";
        return;
      }
      this.actualAmount = this.mark + " " + (this.form.money / this.rate).toFixed(num);
      rateTip = this.mark + " " + (this.form.money * this.charge / 100).toFixed(num);
      if (this.charge > 0) {
        this.chargeTip = this.$t('cash.charge') + rateTip;
      }
    },
    onInput(key) {
      this.psd_val = (this.psd_val + key).slice(0, 6);
      if (this.psd_val.length == 6) {
        this.write_psd = false;
        this.form.password = this.psd_val;
        if (this.submitType == 1) {
          this.submit();
        } else {
          this.setIniPwdSubmit();
        }
      }
    },
    onDelete() {
      this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
    },
    subAll() {
      this.form.money = this.data.money;
    },
    start() {
      Fetch('/user/my_bank').then((r) => {
        this.data = r.data;
        this.data.money = this.data.money.toFixed(2);
        this.setPwd = r.data.intPwd;
        var bankvalue = [];
        r.data.bank.forEach(item => {
          var length = item.account.length;
          var account = item.account + "";
          var itemAccount = account.substr(length - 10, length);
          bankvalue.push({
            name: item.bank + "(****" + itemAccount + ")",
            value: item.id,
            charge: item.charge,
            rate: item.rate,
            type: item.type,
            mark: item.mark
          });
        });
        bankvalue.push({
          name: this.$t('cash.addWallet'),
          value: 0,
          color: "#FF0000",
        });
        this.actions = bankvalue;
        if (bankvalue.length > 1) {
          this.onSelect(bankvalue[0]);
        }
      });
    },
    submit() {
      this.psd_val = "";
      if (!this.form.money) {
        this.$toast(this.$t('cash.withdrawalAmountEmpty'));
        return false;
      }
      if (this.form.money < 0) {
        this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
        return false;
      }
      if (parseInt(this.form.money) > parseInt(this.data.money)) {
        this.$toast(this.$t('cash.withdrawalAmountHigh'));
        return false;
      }
      if (this.form.bank_id == 0 || this.form.bank_id == -1) {
        this.$toast(this.$t('cash.withdrawalAccountEmpty'));
        return false;
      }
      if (!this.form.password || this.form.password.length != 6) {
        this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
        return false;
      }
      Fetch('/user/cost_apply', {
        money: this.form.money,
        bank_id: this.form.bank_id,
        passwd: this.form.password
      }).then(() => {
        this.$toast({
          background: '#07c160',
          message: this.$t('cash.success')
        });
        this.$router.replace('/user');
      });
    },
    setIniPwdSubmit() {
      this.psd_val = "";
      Fetch('/user/setIniPwd', {
        password: this.form.password
      }).then(() => {
        this.setPwd = false;
      });
    },
    setIniPwd() {
      this.submitType = 2;
      this.write_psd = true;
    }
  }
};
</script>

<style lang="less" scoped>
.cash-page {
  min-height: 100vh;
  padding-bottom: 96px;
  background: #fff;
  color: #16223a;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  background: #fff;
  color: #16223a;
  border-bottom: 1px solid rgba(240, 242, 245, 1);
  box-sizing: border-box;

  .back_left {
    opacity: 0.88;
  }

  .big_tit {
    max-width: 72%;
    color: #16223a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.top_right {
  top: 9px;
  right: 15px;
  width: 32px;
  height: 32px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #ff5d7a;
  background: rgba(255, 93, 122, 0.12);
}

.balance-card,
.choose_bank,
.amount-card,
.canal_tips {
  margin: 14px 16px 0;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(255, 93, 122, 0.16);
  background: #fff;
  box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
  box-sizing: border-box;
}

.balance-card {
  padding: 20px 18px;
  text-align: center;
  background: #fff6f8;
}

.balance-card p,
.balance-card span {
  margin: 0;
  color: #6d7688;
  font-size: 14px;
  line-height: 20px;
}

.balance-card strong {
  display: block;
  margin: 10px 0 8px;
  overflow: hidden;
  color: #ff5d7a;
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.wrap1 {
  margin: 0;
  box-shadow: none;
  background: none;
}

.choose_bank {
  min-height: 56px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.choose-label {
  flex: 0 0 auto;
  margin-right: 12px;
  color: #16223a;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.choose-value {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #6d7688;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.choose-value span {
  min-width: 0;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.choose-value .van-icon {
  flex: 0 0 auto;
  margin-left: 6px;
  color: #6d7688;
}

.amount-card {
  padding: 16px;
}

.card-title {
  margin: 0;
  color: #16223a;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.amount-row {
  min-height: 48px;
  margin-top: 14px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background: #fff6f8;
  box-sizing: border-box;
}

.money-mark {
  flex: 0 0 auto;
  margin-right: 8px;
  color: #ff5d7a;
  font-size: 14px;
  font-weight: 700;
}

.amount-row input {
  min-width: 0;
  height: 48px;
  flex: 1;
  border: 0;
  outline: none;
  background: transparent;
  color: #16223a;
  font-size: 14px;
  line-height: 48px;
}

.amount-row input::placeholder {
  color: #6d7688;
}

.amount-row:focus-within {
  box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
}

.amount-row input {
  caret-color: #ff5d7a;
}

.amount-row input:-webkit-autofill,
.amount-row input:-webkit-autofill:hover,
.amount-row input:-webkit-autofill:focus {
  -webkit-text-fill-color: #16223a;
  box-shadow: 0 0 0 1000px #fff6f8 inset;
  caret-color: #ff5d7a;
}

.allbtn {
  width: 72px;
  height: 30px;
  flex: 0 0 72px;
  margin-left: 8px;
  border-radius: 8px;
  border: 1px solid rgba(255, 93, 122, 0.42);
  background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.amount-preview,
.charge-tip {
  margin: 12px 0 0;
  overflow: hidden;
  color: #6d7688;
  font-size: 12px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: normal;
}

.basic_btn {
  width: calc(100% - 32px);
  height: 44px;
  margin: 24px 16px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid rgba(255, 93, 122, 0.42);
  background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  box-sizing: border-box;
}

.canal_tips {
  padding: 14px 16px;
  color: #6d7688;
  font-size: 12px;
  line-height: 20px;
}

/deep/ .van-action-sheet {
  background: #fff;
  color: #16223a;
}

/deep/ .van-action-sheet__description {
  color: #6d7688;
}

/deep/ .van-action-sheet__item {
  background: #fff;
  color: #16223a;
  text-align: left;
}

/deep/ .van-popup--bottom {
  border-radius: 14px 14px 0 0;
}

/deep/ .password-popup {
  background: #fff;
  color: #16223a;
}

/deep/ .password-popup .van-popup__close-icon {
  top: 18px;
  right: 18px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid rgba(109, 118, 136, 0.28);
  background: #fff;
  color: #a6adba;
  font-size: 14px;
}

/deep/ .van-password-input {
  margin: 34px 32px 0;
}

/deep/ .van-password-input__security {
  height: 48px;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(255, 93, 122, 0.24);
  background: #fff6f8;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.72);
}

/deep/ .van-password-input__security li {
  height: 48px;
  background: transparent;
  border-color: rgba(255, 93, 122, 0.16);
  line-height: 48px;
}

/deep/ .van-password-input__security span {
  color: #16223a;
  font-size: 14px;
  font-weight: 700;
  line-height: 48px;
}

/deep/ .van-password-input__security i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #ff5d7a;
  opacity: 1;
  box-shadow: 0 0 0 4px rgba(255, 93, 122, 0.08);
}

/deep/ .van-password-input__cursor {
  width: 1px;
  height: 24px;
  border-radius: 1px;
  background: #ff5d7a;
}

/deep/ .van-hairline--left::after {
  border-color: rgba(255, 93, 122, 0.16);
}

.keybord_box {
  margin-top: 28px;
  padding: 22px 12px 18px;
  background: #fff;
}

.keybord {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  text-align: center;
}

.key_item {
  min-width: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid rgba(255, 93, 122, 0.1);
  background: #fff6f8;
  color: #16223a;
  font-size: 14px;
  font-weight: 700;
  line-height: 44px;
}

.key_item.no_bg {
  border-color: transparent;
  background: transparent;
}

.key_item.x {
  color: #6d7688;
}

.real_name_mask {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.58);
}

.real_box {
  width: calc(100% - 48px);
  padding: 24px 16px;
  border-radius: 14px;
  border: 1px solid rgba(255, 93, 122, 0.16);
  background: #fff;
  box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
  box-sizing: border-box;
}

.tips {
  margin: 0;
  color: #16223a;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
}

@media screen and (max-width: 374px) {
  .balance-card,
  .choose_bank,
  .amount-card,
  .canal_tips {
    margin-right: 12px;
    margin-left: 12px;
  }

  .basic_btn {
    width: calc(100% - 24px);
    margin-right: 12px;
    margin-left: 12px;
  }

  .allbtn {
    width: 62px;
    flex-basis: 62px;
  }
}
.cash-page {
	min-height: 100vh;
	padding-bottom: calc(84px + env(safe-area-inset-bottom));
	background: #201c1d;
	color: #f4ece7;
}

.page-top {
	background: #201c1d;
	color: #f3c99e;
	border-bottom-color: #302723;
}

.page-top .back_left {
	opacity: 1;
	filter: brightness(0) saturate(100%) invert(86%) sepia(18%) saturate(702%) hue-rotate(333deg) brightness(99%) contrast(92%);
}

.page-top .big_tit {
	color: #f3c99e;
}

.top_right {
	color: #f3c99e;
	background: #322b28;
	box-shadow: inset 0 0 0 1px #75654f;
}

.balance-card,
.choose_bank,
.amount-card,
.canal_tips {
	border-color: #75654f;
	background: linear-gradient(110deg, #232323, #303030);
	box-shadow: 0 10px 22px rgba(0, 0, 0, 0.24);
}

.balance-card {
	background: linear-gradient(115deg, #393028, #282524);
}

.balance-card p,
.balance-card span,
.amount-preview,
.charge-tip,
.canal_tips {
	color: #c7af99;
}

.balance-card strong,
.money-mark {
	color: #f3c99e;
}

.choose-label,
.card-title {
	color: #f4ece7;
}

.choose-value,
.choose-value .van-icon {
	color: #b28d6c;
}

.amount-row {
	border-color: #75654f;
	background: #282524;
}

.amount-row input {
	color: #f4ece7;
	caret-color: #f3c99e;
}

.amount-row input::placeholder {
	color: #a99584;
}

.amount-row:focus-within {
	border-color: #f3c99e;
	box-shadow: 0 0 0 3px rgba(243, 201, 158, 0.12);
}

.amount-row input:-webkit-autofill,
.amount-row input:-webkit-autofill:hover,
.amount-row input:-webkit-autofill:focus {
	-webkit-text-fill-color: #f4ece7;
	box-shadow: 0 0 0 1000px #282524 inset;
	caret-color: #f3c99e;
}

.allbtn,
.submit-btn {
	border: 0;
	background: linear-gradient(120deg, #f5cfa8, #dbab73) !important;
	color: #5a4839 !important;
}

.submit-btn {
	box-shadow: 0 7px 16px rgba(0, 0, 0, 0.24);
}

/deep/ .van-action-sheet,
/deep/ .van-popup {
	background: #282524;
}

/deep/ .van-action-sheet__item,
/deep/ .van-cell {
	background: #282524;
	color: #f4ece7;
}

/deep/ .van-action-sheet__description,
/deep/ .van-cell__label {
	color: #b28d6c;
}

/deep/ .van-action-sheet__cancel::before,
/deep/ .van-cell:not(:last-child)::after {
	border-color: #4a4038;
}

/deep/ .van-password-input__security {
	background: #201c1d;
	border-color: #75654f;
}

/deep/ .van-password-input__dot {
	background: #f3c99e;
}

/deep/ .van-password-input__cursor {
	background: #f3c99e;
}

.keybord_box {
	background: #201c1d;
}

.key_item {
	border-color: #75654f;
	background: #302c29;
	color: #f4ece7;
}

.real_box {
	border-color: #75654f;
	background: linear-gradient(110deg, #232323, #303030);
	color: #f4ece7;
}

.real_box .tips,
.real_box p {
	color: #c7af99;
}

@media screen and (max-width: 374px) {
	.balance-card,
	.choose_bank,
	.amount-card,
	.canal_tips {
		margin-right: 8px;
		margin-left: 8px;
	}
}
</style>
